import { i18n } from "@lingui/core";
import { en, es } from "make-plural/plurals";

export const SUPPORTED_LOCALES = ["en", "es"] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

const STORAGE_KEY = "jemma.locale";
const DEFAULT_LOCALE: Locale = "en";

const catalogLoaders: Record<Locale, () => Promise<typeof import("./locales/en/messages")>> = {
  en: () => import("./locales/en/messages"),
  es: () => import("./locales/es/messages"),
};

i18n.loadLocaleData({
  en: { plurals: en },
  es: { plurals: es },
});

export const getDefaultLocale = (): Locale => {
  if (typeof window !== "undefined") {
    const stored = window.localStorage.getItem(STORAGE_KEY) as Locale | null;
    if (stored && SUPPORTED_LOCALES.includes(stored)) {
      return stored;
    }
  }

  if (typeof navigator !== "undefined") {
    const candidates = [
      navigator.language,
      ...(navigator.languages ?? []),
    ]
      .filter(Boolean)
      .map((locale) => locale.split("-")[0] as Locale);

    const matched = candidates.find((locale) =>
      SUPPORTED_LOCALES.includes(locale)
    );

    if (matched) {
      return matched;
    }
  }

  return DEFAULT_LOCALE;
};

export const activateLocale = async (locale: Locale) => {
  const loader = catalogLoaders[locale];
  if (!loader) {
    throw new Error(`Unsupported locale: ${locale}`);
  }

  const { messages } = await loader();
  i18n.load(locale, messages);
  i18n.activate(locale);

  if (typeof window !== "undefined") {
    window.localStorage.setItem(STORAGE_KEY, locale);
    document.documentElement.lang = locale;
  }
};

export { i18n };


  